// src/components/Home.jsx
import { useNavigate } from 'react-router-dom';
import { useTenantConfig } from '../context/TenantConfigContext';

const Home = () => {
  const navigate = useNavigate();
  const { tenantConfig } = useTenantConfig();

  const handleLoginClick = () => {
    navigate('/login');
  };

  const {
    homeTitle,
    homeParagraphs,
    homeBackgroundImageUrl,
  } = tenantConfig;

  return (
    <div className="relative flex flex-col md:flex-row items-center bg-gray-100 min-h-[calc(80vh-45px)]">
      <div className="hidden lg:block lg:min-w-[1000px]">
        <img
          src={homeBackgroundImageUrl || '/images/champs/couple_1.png'}
          alt="Background"
          className="w-full md:w-auto h-auto object-cover"
        />
      </div>
      <div className="absolute top-[10%] left-[5%] w-[90%] max-w-[800px] bg-white bg-opacity-50 flex flex-col p-4 md:p-8">
        <h1 className="text-2xl md:text-5xl font-bold leading-tight">
          {homeTitle}
        </h1>
        <p className="text-base md:text-lg mt-4 leading-relaxed">
          {homeParagraphs?.[0]}
        </p>
        <p className="text-base md:text-lg mt-4 leading-relaxed">
          {homeParagraphs?.[1]}
        </p>
      </div>
    </div>
  );
};

export default Home;
